import { memo, type FC, type PropsWithChildren } from 'react'

import { Box, Dimensions, Text } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
  contentGap?: Dimensions
  contentPaddingTop?: Dimensions
}

const DetailsValue: FC<PropsWithChildren<Props>> = ({
  children,
  label,
  contentGap,
  contentPaddingTop,
}) => {
  if (!children) return null

  return (
    <Box flexDirection="column" width="full">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {label}
      </Text.Normal>
      {typeof children === 'string' ? (
        <Text.Normal size="200" color="grey1000">
          {children}
        </Text.Normal>
      ) : (
        <Box gap={contentGap} paddingTop={contentPaddingTop}>
          {children}
        </Box>
      )}
    </Box>
  )
}

export default memo(DetailsValue)
